import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { StandEnum } from './utils/show-on-stand';
import { store } from './redux/configure-store';

export const SENTRY_CONFIG = {
  dsn: 'https://881b9627887f07d54a844f7df1b40199@o4509012087406592.ingest.us.sentry.io/4509012298366976',
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  // replaysSessionSampleRate: 0.1,
  // // If the entire session is not sampled, use the below sample rate to sample
  // // sessions when an error occurs.
  // replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    // Sentry.replayIntegration({
    //   // Additional SDK configuration goes in here, for example:
    //   maskAllText: false,
    //   blockAllMedia: false,
    // }),
  ],

  tracesSampleRate: 1.0,

  tracePropagationTargets: ['localhost', StandEnum.DEV, StandEnum.PROD],
  beforeSend(event: any) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // const { breadcrumbs, ...rest } = { ...event };
    // const stringEvent = JSON.stringify(rest || '');
    // const isJumio = /jumio/g.test(stringEvent);
    const { applicationId } = { ...store.getState().app };

    // eslint-disable-next-line no-underscore-dangle
    if (event?.extra?.__serialized__?.customError) {
      return { ...event, applicationId };
    }

    return null;
  },
};
